<template>
  <div class="fip-promo">
    <banner-promo
      v-if="bannerDefinition && !hasTicketVideo"
      :promo="bannerDefinition"
      class="bandeau-flexivod" />
  </div>
</template>

<script>
import _get from 'lodash/get'
import API_CONSTANTS from '../../../../api.constants'
import _isEmpty from 'lodash/isEmpty'
import flexivod from '../../../shared/flexivod'
import _groupBy from 'lodash/groupBy'
import _orderBy from 'lodash/orderBy'
import BannerPromo from './../fipHeader/bannerPromo/BannerPromo'
import { mapGetters } from 'vuex'

export default {
  name: 'FipPromo',
  components: { BannerPromo },
  props: {
    item: {
      type: Object,
      required: true
    },
    promoType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selectedQuality: _get(this.item, 'definitions[0].quality', 'SD'),
      definition: null
    }
  },
  computed: {
    ...mapGetters({
      userDiscounts: 'user/getUserDiscounts'
    }),
    orderInfo () {
      return _get(this.item, 'orderInfo', {})
    },
    hasTicketVideo () { // Season must check if all episodes are bought are not, in that case, in that case Season is bought
      switch (this.item.type) {
        case API_CONSTANTS.RESOURCE_TYPES.SEASON:
          return this.item.episodes.every(episode => episode.orderInfo)
        default:
          return !_isEmpty(this.orderInfo)
      }
    },
    bannerDefinition () {
      return (_get(this.selectedDefinition, 'name') || _get(this.selectedDefinition, 'description')) ? this.selectedDefinition : null
    },
    selectedDefinition () {
      return _get(this.definitionsByQuality, this.selectedQuality, [])[0] || {}
    },
    definitionsByQuality () {
      const infoPromos = flexivod.infoPromo(this.userDiscounts, '', this.item.definitions, this.promoType)
      return _groupBy(_orderBy(infoPromos, ['usage'], ['desc']), 'quality')
    }
  }
}
</script>

<style lang="scss" scoped>
.fip-promo {
  max-width: 1280px;
  margin: auto;
  @include mediaQueries('padding', (xsmall: 15px 15px, medium: 28px 27px, large: 2px 55px));
}
</style>
